import { render, staticRenderFns } from "./OlpaSystemMemoView.vue?vue&type=template&id=15a4a8e8&scoped=true&"
import script from "./OlpaSystemMemoView.vue?vue&type=script&lang=js&"
export * from "./OlpaSystemMemoView.vue?vue&type=script&lang=js&"
import style0 from "./OlpaSystemMemoView.vue?vue&type=style&index=0&id=15a4a8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4a8e8",
  null
  
)

/* custom blocks */
import block0 from "./OlpaSystemMemoView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports